export default __webpack_public_path__ + "static/media/S_CoreDream_6Bold.cd51183a.woff";